function setCssVar(name, value) {
  document.documentElement.style.setProperty(name, value);
}

function getCssVar(name) {
  return window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(name);
}

export { setCssVar, getCssVar };
